import { chainInfos } from '@ui/constants/chain';
import { TOKEN_ADDRESS_BY_CHAIN } from '@ui/services/contract/constants';
import { ChainId, ChainName } from '@ui/types/chain';

export type PrivacyPoolConfig = {
  id: string;
  symbol: string;
  chain: string;
  chainId: ChainId;
  scope: string;
  decimals: number;
  logoSrc: string;
  tokenAddress: string;
  poolAddress: string;
  entryPointAddress: string;
  deploymentBlock: bigint;
  sdkRpcUrl: string;
};

const NATIVE_TOKEN_ADDRESS = '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee';

export const PRIVACY_POOLS_ASP_ENDPOINT =
  process.env.NEXT_PUBLIC_PRIVACY_POOLS_ASP_ENDPOINT ||
  'https://asp-release.leverup.xyz';

export const PRIVACY_POOLS_RELAYER_ENDPOINT =
  process.env.NEXT_PUBLIC_PRIVACY_POOLS_RELAYER_ENDPOINT ||
  process.env.NEXT_PUBLIC_MONAD_RELAYER_URL ||
  'https://relayer-release.leverup.xyz';

const MONAD_ENTRYPOINT = '0xb80e1a824a576528dadbfaad4d445e8370107550';
const MONAD_MAINNET_RPC = chainInfos[ChainId.MONAD_MAINNET].rpcUrls[0];
const DEFAULT_MONAD_SDK_RPC_URL =
  process.env.NEXT_PUBLIC_PRIVACY_POOLS_SDK_RPC_URL || MONAD_MAINNET_RPC;

export const privacyPoolsCatalog: PrivacyPoolConfig[] = [
  {
    id: 'mon',
    symbol: 'MON',
    chain: ChainName.MONAD,
    chainId: ChainId.MONAD_MAINNET,
    scope:
      '1424812930471866707034704863110478415400666728607677128341997419932235438589',
    decimals: 18,
    logoSrc: '/tokens/MON.svg',
    tokenAddress: NATIVE_TOKEN_ADDRESS,
    poolAddress: '0x5f27b81c2d32c7261e00bf7eb575e6616fb758e4',
    entryPointAddress: MONAD_ENTRYPOINT,
    deploymentBlock: 64767462n,
    sdkRpcUrl: DEFAULT_MONAD_SDK_RPC_URL,
  },
  {
    id: 'lvmon',
    symbol: 'LVMON',
    chain: ChainName.MONAD,
    chainId: ChainId.MONAD_MAINNET,
    scope:
      '412119270359744370365301555361741393413065116173050730519273992916458263250',
    decimals: 18,
    logoSrc: '/tokens/LVMON.svg',
    tokenAddress: TOKEN_ADDRESS_BY_CHAIN[ChainId.MONAD_MAINNET].LVMON,
    poolAddress: '0xcA81c6B81953854491e885140EA56e2509186A7D',
    entryPointAddress: MONAD_ENTRYPOINT,
    deploymentBlock: 64768866n,
    sdkRpcUrl: DEFAULT_MONAD_SDK_RPC_URL,
  },
  {
    id: 'usdc',
    symbol: 'USDC',
    chain: ChainName.MONAD,
    chainId: ChainId.MONAD_MAINNET,
    scope:
      '12085890916698811347789905976162471911282520568228057542026817243888598703542',
    decimals: 6,
    logoSrc: '/tokens/USDC.svg',
    tokenAddress: TOKEN_ADDRESS_BY_CHAIN[ChainId.MONAD_MAINNET].USDC,
    poolAddress: '0x11a5e153e862F70E57B7333A41e35CcCE5F90E6B',
    entryPointAddress: MONAD_ENTRYPOINT,
    deploymentBlock: 64768866n,
    sdkRpcUrl: DEFAULT_MONAD_SDK_RPC_URL,
  },
  {
    id: 'lvusd',
    symbol: 'LVUSD',
    chain: ChainName.MONAD,
    chainId: ChainId.MONAD_MAINNET,
    scope:
      '11077033619328219887419183061932448672329944304071973276959806027945889818836',
    decimals: 18,
    logoSrc: '/tokens/LVUSD.svg',
    tokenAddress: TOKEN_ADDRESS_BY_CHAIN[ChainId.MONAD_MAINNET].LVUSD,
    poolAddress: '0x188b6fB6Ad79cd942c7c4f20cB499F5590edD367',
    entryPointAddress: MONAD_ENTRYPOINT,
    deploymentBlock: 64768866n,
    sdkRpcUrl: DEFAULT_MONAD_SDK_RPC_URL,
  },
  // {
  //   id: 'mlmon-test',
  //   symbol: 'mlMON(Test)',
  //   chain: ChainName.MONAD,
  //   chainId: ChainId.MONAD_MAINNET,
  //   scope:
  //     '5000634142452859954438104446625358047329044996895089609970044286713655389799',
  //   decimals: 18,
  //   logoSrc: '/tokens/MON.svg',
  //   tokenAddress: '0xd5c1c5798c97de68c9a55b5f5090ff76a5d0dabd',
  //   poolAddress: '0xB60CBfE2dE8aaE2CF90dFF22ff7b313ac15F0DFB',
  //   entryPointAddress: MONAD_ENTRYPOINT,
  //   deploymentBlock: 65259095n,
  //   sdkRpcUrl: DEFAULT_MONAD_SDK_RPC_URL,
  // },
];

const privacyPoolsByScope = new Map(
  privacyPoolsCatalog.map((pool) => [pool.scope, pool]),
);
const privacyPoolsById = new Map(
  privacyPoolsCatalog.map((pool) => [pool.id, pool]),
);

export const getPrivacyPoolConfigByScope = (scope?: string) => {
  return scope ? privacyPoolsByScope.get(scope) : undefined;
};

export const getPrivacyPoolConfigById = (id?: string) => {
  return id ? privacyPoolsById.get(id) : undefined;
};
